module.exports = __webpack_public_path__ + "static/img/case-right.cb2274d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case-right.png
// module id = nFPk
// module chunks = 1